import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import QuestionForm from '../../../components/forms/QuestionForm';
import { useQuestionApi } from '../../../hooks/useQuestionApi';
import { useNavigate, useParams } from 'react-router-dom';
import { QuestionDTO } from '../../../services/apiClient';
import { useQuestionSetApi } from '../../../hooks/useQuestionSetApi';

const QuestionCreate: React.FC = () => {
  const { create } = useQuestionApi();
  const { getById } = useQuestionSetApi();
  const navigate = useNavigate();
  const { questionSetId } = useParams<{ questionSetId: string }>();
  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: `Question Set`, href: `/admin/questionsets/${questionSetId}` },
    { label: `Questions`, href: `/admin/questionsets/${questionSetId}/questions` },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: QuestionDTO) => {
    try {
      await create(data);
      navigate(`/admin/questionsets/${questionSetId}`);
    } catch (error) {
      console.error('Error creating Question:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/questionsets"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Content.Question.Edit'
    >
        <QuestionForm
          initialValues={{questionSetId: questionSetId} as QuestionDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate(`/admin/questionsets/${questionSetId}`)}
        />
    </AdminLayout>
  );
};

export default QuestionCreate;